/* eslint-disable security/detect-object-injection */
/* eslint-disable camelcase */
import managerInventory from "./managerInventory";

// eslint-disable-next-line consistent-return
const getInventoryDetails = async (id = "", isSerp = false) => {
  const ids = id.split("|").map(pId => Number(pId)) || [];
  try {
    const { data: { data = {} } = {} } = await managerInventory(id);
    let invResp = {};
    ids.forEach(pid => {
      const inventory = data.find(item => item.productId === pid);
      if (inventory) {
        const { stock = 0, shippingType, membershipShippingType } = inventory;
        const available = stock > 0;
        invResp[pid] = {
          available: available,
          count: stock > 50 ? 50 : stock,
          message:
            available &&
            stock < 6 &&
            `${stock} ${stock !== 1 ? "Units" : "Unit"} Left`,
          dropCount: stock > 50 ? 50 : stock,
          isFreeShipping: shippingType === "Free",
          isFreeShippingForMembers: membershipShippingType === "Free"
        };
      } else
        invResp[pid] = {
          available: true,
          count: 50,
          message: false,
          dropCount: 50,
          isFreeShipping: false,
          isFreeShippingForMembers: false
        };
    });
    if (Object.keys(invResp).length === 1 && !isSerp)
      invResp = invResp[Object.keys(invResp)[0]];
    return invResp;
  } catch {
    let respObj = ids.reduce((obj, pId) => {
      // eslint-disable-next-line no-param-reassign
      obj[pId] = {
        available: true,
        count: 50,
        message: true,
        dropCount: 50
      };
      return obj;
    }, {});
    if (Object.keys(respObj).length === 1 && !isSerp)
      respObj = respObj[Object.keys(respObj)[0]];
    return respObj;
  }
};

export default getInventoryDetails;
